import actions from './actions';
import mutations from './mutations';
import stateFactory from './state';

const state = stateFactory.getDefaultState();

export default {
    namespaced: true,
    state,
    actions,
    mutations
};